import { GAME_ID, REDUX_ACTIONS, ANSWER_TYPE } from '../../data/constants';

const initState = {
  // Curriculum Pointers
  lastLevelClicked: 0,
  levelId: 0,
  questionIndex: 0,
  questionIdsInRound: [],
  progressAmount: 0,
  selectedResponse: undefined,
  incorrectSubmissionsCount: 0,
  currentAnswerType: ANSWER_TYPE.NO_ANSWER,
  isIntroSceneComplete: false,
  isShowingDiaryPanel: false,
  isShowingHeadlinesMenu: false,
  headlineIndex: 0,
  headlineText: undefined,
  isShowingFinalPayoffPhone: false,
  currentPoV: 0,
  currentGuidedSequenceName: '',
  isReturningUser: false,
  isFinalItemComplete: false,
  records: [],
};

const roundPlayReducer = (state = initState, { type, payload, gameId }) => {
  if (gameId !== GAME_ID) {
    return state;
  }

  switch (type) {
    case REDUX_ACTIONS.START_OBOARDING:
    case REDUX_ACTIONS.REPEAT_ONBOARDING:
      return {
        ...state,
        levelId: 0,
        isShowingDiaryPanel: false,
        isShowingHeadlinesMenu: false,
        isShowingFinalPayoffPhone: false,
        currentPoV: 0,
      };

    case REDUX_ACTIONS.COMPLETE_INTRO_SCENE:
      return {
        ...state,
        isIntroSceneComplete: true,
      };

    case REDUX_ACTIONS.SET_LEVEL_ID:
      return {
        ...state,
        levelId: payload,
        isShowingDiaryPanel: false,
        isShowingHeadlinesMenu: false,
        isShowingFinalPayoffPhone: false,
        isFinalItemComplete: false,
        currentPoV: 0,
      };

    case REDUX_ACTIONS.INITIALIZE_ROUND:
      return {
        ...state,
        isReturningUser: payload.isReturningUser,
        questionIdsInRound: payload.questionIdsInRound,
        questionIndex: payload.startingQuestionIndex,
        currentPoV: payload.startingPoV,
        progressAmount: ((payload.startingQuestionIndex) / (payload.questionIdsInRound.length)) * 100,
        incorrectSubmissionsCount: 0,
        currentAnswerType: ANSWER_TYPE.NO_ANSWER,
        selectedResponse: undefined,
        headlineIndex: -1,
        records: payload.records,
        headlineText: 'no headline selected',
      };

    case REDUX_ACTIONS.RESET_FEEDBACK:
      return {
        ...state,
        currentAnswerType: ANSWER_TYPE.NO_ANSWER,
      };

    case REDUX_ACTIONS.SELECT_RESPONSE:
      return {
        ...state,
        isFinalItemComplete: payload.isFinalItemComplete,
        mostRecentAnswerCorrectness: payload.isCorrect,
      };

    case REDUX_ACTIONS.SELECT_FEEDBACK: {
      const { isCorrect } = payload;
      const { incorrectSubmissionsCount } = state;
      return {
        ...state,
        incorrectSubmissionsCount: isCorrect ? incorrectSubmissionsCount : incorrectSubmissionsCount + 1,
        currentAnswerType: isCorrect ? ANSWER_TYPE.CORRECT : ANSWER_TYPE.INCORRECT,
      };
    }

    case REDUX_ACTIONS.SET_ANSWER_AS_PENDING:
      return {
        ...state,
        currentAnswerType: ANSWER_TYPE.PENDING,
      };

    case REDUX_ACTIONS.COMPLETE_CHECKPOINT_ITEM:
      return {
        ...state,
        currentPoV: state.currentPoV + 1,
      };

    case REDUX_ACTIONS.UPDATE_RECORDS:
      return {
        ...state,
        records: [...state.records, payload],
      };

    case REDUX_ACTIONS.NEXT_STANDARD_ITEM:
      return {
        ...state,
        progressAmount: state.questionIndex >= state.questionIdsInRound.length - 1
          ? 100
          : state.progressAmount + (100 / state.questionIdsInRound.length),
        questionIndex: Math.min(state.questionIndex + 1, state.questionIdsInRound.length - 1),

        incorrectSubmissionsCount: 0,
        currentAnswerType: ANSWER_TYPE.NO_ANSWER,
      };

    case REDUX_ACTIONS.QUICK_ROUND: {
      const progress = payload ? 100 : 0;
      return {
        ...state,
        progressAmount: progress,
        questionIndex: state.questionIdsInRound.length,
      };
    }

    case REDUX_ACTIONS.TOGGLE_DIARY_PANEL:
      return {
        ...state,
        isShowingDiaryPanel: !state.isShowingDiaryPanel,
      };

    case REDUX_ACTIONS.SHOW_HEADLINES_MENU:
      return {
        ...state,
        isShowingHeadlinesMenu: true,
        currentGuidedSequenceName: 'heresYourChanceTo',
      };

    case REDUX_ACTIONS.SELECT_HEADLINE_TEXT:
      return {
        ...state,
        headlineIndex: payload.index,
        headlineText: payload.headlineText,
        currentGuidedSequenceName: '',
      };

    case REDUX_ACTIONS.SHOW_FINAL_PAYOFF_PHONE:
      return {
        ...state,
        isShowingFinalPayoffPhone: true,
      };

    case REDUX_ACTIONS.SET_CURRENT_GUIDED_SEQUENCE_NAME:
      return {
        ...state,
        currentGuidedSequenceName: payload,
      };

    case REDUX_ACTIONS.CHANGE_SCREEN:
    case REDUX_ACTIONS.STOP_VO:
    case REDUX_ACTIONS.END_OF_GUIDED_SEQUENCE:
      return {
        ...state,
        currentGuidedSequenceName: '',
      };

    case REDUX_ACTIONS.SET_LAST_LEVEL_CLICKED:
      return {
        ...state,
        lastLevelClicked: payload,
      };

    default:
      return state;
  }
};

export default roundPlayReducer;
